import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Skeleton } from 'components/UnvUI'

import $api from 'http/index'

import styles from './SciencePage.module.scss'

const SciencePage = () => {
  const { t } = useTranslation('common')
  const [tab, setTab] = useState('publications')
  const [publications, setPublications] = useState([])
  const [grants, setGrants] = useState([])
  const [loadingPub, setLoadingPub] = useState(true)
  const [loadingGr, setLoadingGr] = useState(true)
  const [errorPub, setErrorPub] = useState(false)
  const [errorGr, setErrorGr] = useState(false)

  useEffect(() => {
    const loadPub = async () => {
      setLoadingPub(true)
      setErrorPub(false)
      try {
        const res = await $api.get('/science/publications/')
        setPublications(res.data?.results || res.data || [])
      } catch {
        setErrorPub(true)
        setPublications([])
      } finally {
        setLoadingPub(false)
      }
    }
    const loadGr = async () => {
      setLoadingGr(true)
      setErrorGr(false)
      try {
        const res = await $api.get('/science/grants/')
        setGrants(res.data?.results || res.data || [])
      } catch {
        setErrorGr(true)
        setGrants([])
      } finally {
        setLoadingGr(false)
      }
    }
    loadPub()
    loadGr()
  }, [])

  return (
    <div className={styles.page}>
      <div className={`unv-card ${styles.header}`}>
        <h1 className={styles.title}>{t('science.title_page')}</h1>
      </div>

      <div className={`unv-card ${styles.tabsWrap}`}>
        <div className={styles.tabs}>
          <button
            className={`unv-btn ${tab === 'publications' ? '' : 'unv-btn--ghost'}`}
            onClick={() => setTab('publications')}
          >
            {t('science.tab_publications')}
          </button>
          <button
            className={`unv-btn ${tab === 'grants' ? '' : 'unv-btn--ghost'}`}
            onClick={() => setTab('grants')}
          >
            {t('science.tab_grants')}
          </button>
        </div>
      </div>

      <div className={`unv-card ${styles.content}`}>
        {tab === 'publications' && (
          <>
            {loadingPub ? (
              <div className={styles.loaderWrap}>
                <Skeleton variant="table" rows={5} cols={4} />
              </div>
            ) : errorPub ? (
              <div className="unv-empty">{t('science.section_in_dev')}</div>
            ) : publications.length === 0 ? (
              <div className="unv-empty">{t('science.no_publications')}</div>
            ) : (
              <table className="unv-table">
                <thead>
                  <tr>
                    <th>{t('science.col_title')}</th>
                    <th>{t('science.col_authors')}</th>
                    <th>{t('science.col_journal')}</th>
                    <th>{t('science.col_year')}</th>
                    <th>{t('science.col_doi')}</th>
                    <th>{t('science.col_indexing')}</th>
                  </tr>
                </thead>
                <tbody>
                  {publications.map((p) => (
                    <tr key={p.id}>
                      <td>{p.title || '—'}</td>
                      <td>
                        {Array.isArray(p.authors) ? p.authors.join(', ') : p.authors_text || '—'}
                      </td>
                      <td>{p.journal || '—'}</td>
                      <td>{p.year || '—'}</td>
                      <td>
                        {p.doi ? (
                          <a href={`https://doi.org/${p.doi}`} target="_blank" rel="noreferrer">
                            {p.doi}
                          </a>
                        ) : (
                          '—'
                        )}
                      </td>
                      <td>
                        {Array.isArray(p.indexing) && p.indexing.length > 0
                          ? p.indexing.map((i) => (
                              <span key={i} className="unv-badge unv-badge--muted">
                                {i}
                              </span>
                            ))
                          : p.indexing || '—'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}

        {tab === 'grants' && (
          <>
            {loadingGr ? (
              <div className={styles.loaderWrap}>
                <Skeleton variant="table" rows={5} cols={4} />
              </div>
            ) : errorGr ? (
              <div className="unv-empty">{t('science.section_in_dev')}</div>
            ) : grants.length === 0 ? (
              <div className="unv-empty">{t('science.no_grants')}</div>
            ) : (
              <table className="unv-table">
                <thead>
                  <tr>
                    <th>{t('science.col_title')}</th>
                    <th>{t('science.col_funder')}</th>
                    <th>{t('science.col_lead')}</th>
                    <th>{t('science.col_amount')}</th>
                    <th>{t('science.col_dates')}</th>
                    <th>{t('science.col_status')}</th>
                  </tr>
                </thead>
                <tbody>
                  {grants.map((g) => (
                    <tr key={g.id}>
                      <td>{g.title || '—'}</td>
                      <td>{g.funder || '—'}</td>
                      <td>{g.lead || g.lead_name || '—'}</td>
                      <td>{g.amount != null ? `${g.amount} ${g.currency || 'сом'}` : '—'}</td>
                      <td>
                        {g.start_date && g.end_date
                          ? `${new Date(g.start_date).toLocaleDateString('ru-RU')} — ${new Date(g.end_date).toLocaleDateString('ru-RU')}`
                          : '—'}
                      </td>
                      <td>
                        <span className="unv-badge">{g.status || '—'}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default SciencePage
